<template>
	<div class="contact" :class="{ 'dark-theme': isDarkMode }">
		<div class="container">
			<h1>Kontakt</h1>
			<form @submit.prevent="submitForm" class="contact-form">
				<!-- Wybór kategorii na górze -->
				<div class="form-group">
					<label for="category">Kategoria</label>
					<select id="category" v-model="form.category" required @change="onCategoryChange">
						<option value="" disabled selected>Wybierz kategorię</option>
						<option value="Sztuczna Inteligencja">Sztuczna Inteligencja</option>
						<option value="Usługi IT">Szkolenia Sztucznej Inteligencji</option>
						<option value="Język Angielski">Język Angielski</option>
						<option value="Inne">Inne zapytanie</option>
					</select>
				</div>

				<!-- Pola zależne od kategorii -->
				<template v-if="form.category === 'Sztuczna Inteligencja'">
					<div class="form-group">
						<label for="fullName">Imię i Nazwisko</label>
						<input type="text" id="fullName" v-model="form.fullName" required placeholder="Jan Kowalski" />
					</div>
					<div class="form-group">
						<label for="companyName">Nazwa Firmy</label>
						<input type="text" id="companyName" v-model="form.companyName" required
							placeholder="Nazwa Twojej Firmy" />
					</div>
					<div class="form-group">
						<label for="phone">Telefon</label>
						<input type="tel" id="phone" v-model="form.phone" required placeholder="+48 123 456 789" />
					</div>
					<div class="form-group">
						<label for="email">E-mail *</label>
						<input type="email" id="email" v-model="form.email" required
							placeholder="jan.kowalski@example.com" />
					</div>
					<div class="form-group">
						<label for="projectDescription">Opis projektu *</label>
						<textarea id="projectDescription" v-model="form.projectDescription" required
							placeholder="Opisz swój projekt..."></textarea>
					</div>
				</template>

				<!-- Standardowe pola dla innych kategorii -->
				<template v-else-if="form.category">
					<div class="form-group">
						<label for="fullName">Imię i Nazwisko</label>
						<input type="text" id="fullName" v-model="form.fullName" required placeholder="Jan Kowalski" />
					</div>
					<div class="form-group">
						<label for="phone">Telefon</label>
						<input type="tel" id="phone" v-model="form.phone" required placeholder="+48 123 456 789" />
					</div>
					<div class="form-group">
						<label for="email">E-mail *</label>
						<input type="email" id="email" v-model="form.email" required
							placeholder="jan.kowalski@example.com" />
					</div>
					<div class="form-group">
						<label for="message">Wiadomość *</label>
						<textarea id="message" v-model="form.message" required
							placeholder="Wpisz swoją wiadomość..."></textarea>
					</div>
				</template>

				<button type="submit" :disabled="isSubmitting || !form.category">Wyślij</button>
				<p v-if="submissionMessage" class="submission-message" :class="messageClass">{{ submissionMessage }}</p>
			</form>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	inject: ['theme'],
	data() {
		return {
			form: {
				category: '',
				fullName: '',
				companyName: '',
				phone: '',
				email: '',
				message: '',
				projectDescription: '',
			},
			isSubmitting: false,
			submissionMessage: '',
		};
	},
	computed: {
		isDarkMode() {
			return this.theme.isDarkMode;
		},
		// Dynamiczna klasa dla wiadomości zwrotnej
		messageClass() {
			if (this.submissionMessage.toLowerCase().includes('błąd')) {
				return 'error';
			} else if (this.submissionMessage.toLowerCase().includes('pomyślnie')) {
				return 'success';
			}
			return ''; // Domyślna klasa, jeśli wiadomość nie pasuje do żadnego wzorca
		},
	},
	methods: {
		async submitForm() {
			this.isSubmitting = true;
			this.submissionMessage = '';

			// Przygotuj dane do wysłania (dostosuj do wymagań PHP)
			const payload = {
				fullName: this.form.fullName,
				companyName: this.form.category === 'Sztuczna Inteligencja' ? this.form.companyName : '',
				phone: this.form.phone,
				email: this.form.email,
				message: this.form.category !== 'Sztuczna Inteligencja' ? this.form.message : '',
				projectDescription: this.form.category === 'Sztuczna Inteligencja' ? this.form.projectDescription : ''
			};

			try {
				// Zastąp URL swoim adresem na Seohost
				const response = await axios.post('https://d4quality.pl/send-email.php', payload, {
					headers: {
						'Content-Type': 'application/json'
					}
				});
				this.submissionMessage = response.data.message || 'Wiadomość została wysłana pomyślnie!';
				this.resetForm();
			} catch (error) {
				console.error('Błąd podczas wysyłania wiadomości:', error.response ? error.response.data : error.message);
				this.submissionMessage = error.response?.data?.message || 'Wystąpił błąd podczas wysyłania wiadomości. Prosimy o kontakt: kontakt@d4quality.pl';
			} finally {
				this.isSubmitting = false;
			}
		},
		onCategoryChange() {
			this.form.fullName = '';
			this.form.companyName = '';
			this.form.phone = '';
			this.form.email = '';
			this.form.message = '';
			this.form.projectDescription = '';
		},
		resetForm() {
			this.form = {
				category: '',
				fullName: '',
				companyName: '',
				phone: '',
				email: '',
				message: '',
				projectDescription: '',
			};
		},
	},
};
</script>

<style scoped>
/* Ogólne style */
.contact {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	transition: all 0.3s ease;
}

/* Kontener dla spójnej szerokości */
.container {
	max-width: 1200px;
	margin: 0 auto;
	padding: 40px 20px;
}

/* Jasny motyw */
.contact:not(.dark-theme) {
	background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
	color: #1f2937;
}

/* Ciemny motyw */
.contact.dark-theme {
	background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
	color: #f9fafb;
}

/* Nagłówek */
.contact h1 {
	font-size: 2.5rem;
	font-weight: 700;
	color: #00b4d8;
	text-align: center;
	margin-bottom: 40px;
}

.contact h2.error {
	font-size: 1.5rem;
	font-weight: 500;
	color: #ef4444;
	/* Czerwony dla jasnego motywu */
	text-align: center;
	margin-bottom: 20px;
}

.dark-theme .contact h2.error {
	color: #f87171;
	/* Jaśniejszy czerwony dla ciemnego motywu */
}

/* Formularz */
.contact-form {
	background: #fff;
	border-radius: 12px;
	padding: 50px;
	box-shadow: 0 6px 25px rgba(0, 0, 0, 0.1);
	max-width: 1000px;
	margin: 0 auto;
}

.dark-theme .contact-form {
	background: #2d2d2d;
}

/* Grupy pól */
.form-group {
	display: flex;
	flex-direction: column;
	gap: 15px;
	/* Większy odstęp między polem a etykietą */
	margin-bottom: 35px;
	/* Większy odstęp między grupami */
}

.form-group label {
	font-size: 1.2rem;
	font-weight: 600;
	color: #00b4d8;
}

/* Pola formularza */
.form-group input,
.form-group select,
.form-group textarea {
	padding: 16px 20px;
	border: 2px solid #e5e7eb;
	border-radius: 10px;
	font-size: 1.1rem;
	transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.dark-theme .form-group input,
.dark-theme .form-group select,
.dark-theme .form-group textarea {
	background: #374151;
	border-color: #4b5563;
	color: #f9fafb;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
	outline: none;
	border-color: #00b4d8;
	box-shadow: 0 0 5px rgba(0, 180, 216, 0.5);
}

/* Select - Poprawiona widoczność strzałki w trybie ciemnym */
.form-group select {
	appearance: none;
	background: url('data:image/svg+xml;utf8,<svg fill="%236b7280" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>') no-repeat right 15px center;
	background-size: 18px;
	padding-right: 50px;
}

.dark-theme .form-group select {
	background: url('data:image/svg+xml;utf8,<svg fill="%23ffffff" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>') no-repeat right 15px center;
	background-color: #374151;
}

/* Textarea */
.form-group textarea {
	height: 180px;
	resize: vertical;
}

/* Przycisk */
button {
	display: block;
	width: 300px;
	padding: 18px;
	margin: 40px auto 0;
	background: #00b4d8;
	color: #fff;
	border: none;
	border-radius: 10px;
	font-size: 1.2rem;
	font-weight: 600;
	cursor: pointer;
	transition: background 0.3s ease, transform 0.2s ease;
}

button:hover:not(:disabled) {
	background: #ff0000;
	transform: translateY(-2px);
}

button:disabled {
	background: #9ca3af;
	cursor: not-allowed;
}

/* Wiadomość zwrotna */
.submission-message {
	margin-top: 20px;
	text-align: center;
	font-size: 1rem;
	font-weight: 500;
}

/* Sukces (zielony) */
.submission-message.success {
	color: #10b981;
	/* Zielony dla jasnego motywu */
}

.dark-theme .submission-message.success {
	color: #34d399;
	/* Jaśniejszy zielony dla ciemnego motywu */
}

/* Błąd (czerwony) */
.submission-message.error {
	color: #ef4444;
	/* Czerwony dla jasnego motywu */
}

.dark-theme .submission-message.error {
	color: #f87171;
	/* Jaśniejszy czerwony dla ciemnego motywu */
}

/* Responsywność */
@media (max-width: 1024px) {
	.contact-form {
		max-width: 800px;
		padding: 40px;
	}

	.form-group input,
	.form-group select,
	.form-group textarea {
		padding: 14px 18px;
	}

	.form-group textarea {
		height: 150px;
	}

	button {
		width: 250px;
	}
}

@media (max-width: 768px) {
	.contact h1 {
		font-size: 2rem;
	}

	.contact-form {
		max-width: 100%;
		padding: 20px;
	}

	.form-group {
		margin-bottom: 30px;
		/* Mniejszy odstęp na smartfonach */
	}

	.form-group input,
	.form-group select,
	.form-group textarea {
		padding: 12px 14px;
	}

	.form-group textarea {
		height: 120px;
	}

	.form-group label {
		font-size: 1.1rem;
	}

	button {
		width: 200px;
		padding: 14px;
	}
}

@media (max-width: 480px) {
	.contact h1 {
		font-size: 1.8rem;
	}

	.contact-form {
		padding: 15px;
	}

	.form-group {
		margin-bottom: 25px;
		/* Jeszcze mniejszy odstęp */
	}

	.form-group input,
	.form-group select,
	.form-group textarea {
		padding: 10px 12px;
	}

	.form-group textarea {
		height: 100px;
	}

	.form-group label {
		font-size: 1rem;
	}

	button {
		width: 150px;
		padding: 12px;
	}
}
</style>